import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class MultiDropdownQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.MULTI_DROPDOWN;
  options: {
    key: string;
    name: string;
    value: string;
  }[] = [];
  okText: string;
  cancelText: string;
  defaultValue: number;

  constructor(options: any = {}) {
    super(options);
    this.options = options['options'] || [];
    this.okText = options['okText'] || 'OK';
    this.cancelText = options['cancelText'] || 'CANCEL';
    this.defaultValue = options['defaultValue'] || undefined;
  }
}
